<template>
  <tr>
    <td class="border border-gray-600 p-2">
      {{ props.name }}
    </td>
    <td class="border border-gray-600 p-2 whitespace-normal break-all flex">



      <span v-if="enabled"
            class="w-3 h-3 mt-1 mr-1 bg-green-500 rounded-full"></span>
      <span v-else
            class="w-3 h-3 mt-1 mr-1 bg-red-500 rounded-full"></span>
      <slot/>
    </td>
  </tr>
</template>
<script setup>

const props = defineProps({
  name: String,
  enabled: {
    type: [Boolean, null],
    default: null
  },
});


</script>